<script>
  console.log('Dashboard/index.svelte script started');
  import { onMount } from 'svelte'
  import { tick } from 'svelte'
  import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    Form,
    FormGroup,
    Label,
  } from 'sveltestrap'
  import { Link } from 'svelte-routing'
  import WelcomeComp from './WelcomeComp.svelte'
  import LatestTransactions from './LatestTransactions.svelte'
  import MonthlyEarning from './MonthlyEarning.svelte'
  import Breadcrumbs from '../../common/Breadcrumb.svelte'
  import 'leaflet/dist/leaflet.css'

  import { user } from '../../services/user.js'
  import DashboardSkeleton from '../DashboardSkeleton.svelte'
  import MapContainer from '../../Components/MapContainer.svelte' // Componente del mapa independiente

  let loading = true
  let dataPage = ''

  // Reactive statement to log user store changes
  $: console.log('Dashboard: $user store value changed:', $user);

  async function getData() {
    let location = (await localStorage.getItem('LANGUAGE')) || 'es-CL'
    if (location === 'es') {
      location = 'es-CL'
    }
    const requestOptions = { method: 'GET', redirect: 'follow' }
    try {
      const res = await fetch(
        `https://api.rastros.cl/api/home-screen?populate=%2A&locale=${location}`,
        requestOptions
      )
      const result = await res.json()
      dataPage = result.data
    } catch (error) {
      console.log('Error al contactar al servicio de home-screen: ', error)
    }
  }

  // Extraer patentes de camiones (para filtro o muestra en la tabla)
  let truckPatents = []
  $: if (
    $user &&
    $user.new_profile &&
    $user.new_profile.new_company &&
    Array.isArray($user.new_profile.new_company.new_trucks)
  ) {
    truckPatents = $user.new_profile.new_company.new_trucks.map(
      (truck) => truck.Patent
    )
  }

  // Opciones de dispositivos (sólo para ejemplo de select de filtros)
  let optionsDevices = []
  $: if (
    $user &&
    $user.new_profile &&
    $user.new_profile.new_company &&
    Array.isArray($user.new_profile.new_company.new_trucks)
  ) {
    let deviceCount = 0
    $user.new_profile.new_company.new_trucks.forEach((truck) => {
      if (Array.isArray(truck.new_tanks)) {
        truck.new_tanks.forEach((tank) => {
          if (Array.isArray(tank.new_devices)) {
            deviceCount += tank.new_devices.length
          }
        })
      }
    })
    if (deviceCount === 1) optionsDevices = ['Uno']
    else if (deviceCount === 2) optionsDevices = ['Uno', 'Dos']
    else if (deviceCount === 3) optionsDevices = ['Uno', 'Dos', 'Tres']
    else if (deviceCount >= 4) optionsDevices = ['Cuatro o más']
    else optionsDevices = []
  }

  onMount(async () => {
    console.log('Dashboard: onMount - Initial $user value:', $user);
    await getData()
    await tick() // Espera a que el DOM se actualice
    loading = false
  })

  window.addEventListener('storage', (event) => {
    if (event.key === 'LANGUAGE') {
      console.log('Language changed')
    }
  })

  // Coordenadas para MapContainer
  const start = [-33.440257242872434, -70.841459559616412]
  const end = [-33.405457716223395, -70.5981734942654]
</script>

{#if loading}
  <DashboardSkeleton />
{:else}
  <div class="page-content">
    <Container fluid>
      <Breadcrumbs title="Dashboards" breadcrumbItem="Dashboard Home" />
      <Row style="margin-bottom: 20px;">
        <Col xl="3">
          <WelcomeComp />
        </Col>
        <Col xl="4">
          <MonthlyEarning />
        </Col>
        <Col xl="5">
          <Card class="mini-stats-wid" style="height: 93%;">
            <CardBody>
              <Row>
                <!-- Tarjeta con datos de alertas y usuario -->
                <Col md="6">
                  <Card class="h-100">
                    <div>
                      <Row>
                        <Col lg="12" sm="12">
                          <div class="p-8">
                            <h5 class="text-primary">{dataPage.alertsTitle}</h5>
                            <p>
                              {dataPage.patentPondLabel}: {truckPatents[0] ||
                                'N/A'}
                            </p>
                            <div class="text-muted">
                              <p class="mb-1">
                                <i
                                  class="mdi mdi-circle-medium align-middle text-primary me-1"
                                ></i>
                                {dataPage.origenLabel}: {($user?.new_profile
                                  ?.new_company?.new_origins &&
                                  $user.new_profile.new_company.new_origins[0]
                                    ?.Name) ||
                                  'Origen no definido'}
                              </p>
                              <p class="mb-1">
                                <i
                                  class="mdi mdi-circle-medium align-middle text-primary me-1"
                                ></i>
                                {dataPage.destinationLabel}: {($user
                                  ?.new_profile?.new_company
                                  ?.new_destinations &&
                                  $user.new_profile.new_company
                                    .new_destinations[0]?.Address) ||
                                  'Destino no definido'}
                              </p>
                              <p class="mb-0">
                                <i
                                  class="mdi mdi-circle-medium align-middle text-primary me-1"
                                ></i>
                                {dataPage.dateLabel}: {$user
                                  ? new Date(
                                      $user.createdAt
                                    ).toLocaleDateString()
                                  : new Date().toLocaleDateString()}
                              </p>
                              <p class="mb-0">
                                <i
                                  class="mdi mdi-circle-medium align-middle text-primary me-1"
                                ></i>
                                {dataPage.hourLabel}: {$user
                                  ? new Date(
                                      $user.createdAt
                                    ).toLocaleTimeString()
                                  : new Date().toLocaleTimeString()}
                              </p>
                              <p class="mb-0">
                                <i
                                  class="mdi mdi-circle-medium align-middle text-primary me-1"
                                ></i>
                                {dataPage.localizationLabel}: {$user?.email ||
                                  'N/A'}
                              </p>
                              <p class="mb-0">
                                <i
                                  class="mdi mdi-circle-medium align-middle text-primary me-1"
                                ></i>
                                {dataPage.latitudeLabel}: {$user?.new_profile
                                  ?.new_company?.Latitude || '-33.0247407'}
                              </p>
                              <p class="mb-0">
                                <i
                                  class="mdi mdi-circle-medium align-middle text-primary me-1"
                                ></i>
                                {dataPage.longitudeLabel}: {$user?.new_profile
                                  ?.new_company?.Longitude || '-71.4061115'}
                              </p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
                <!-- Tarjeta de estado de alerta -->
                <Col md="6">
                  <Card class="h-100">
                    <div>
                      <Row>
                        <Col lg="12" sm="12">
                          <div class="p-8">
                            <h5 class="texto text-primary">
                              {dataPage.alertStateTitle}
                            </h5>
                            <div class="text-muted alert">
                              <h4>Válvula atascada</h4>
                              <i class="icono mdi mdi-engine-off-outline red"
                              ></i>
                            </div>
                          </div>
                        </Col>
                        <Col sm="12">
                          <div class="text-sm-end texto">
                            <Link to={dataPage.moreAlertsLink}>
                              <button
                                type="button"
                                class="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2"
                              >
                                <i class="bx bx-show me-1"
                                ></i>{dataPage.moreAlertsButton}
                              </button>
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col lg="12">
          <div class="mb-4 h4 card-title">{dataPage.mapTitle}</div>
          <Form>
            <Row>
              <Col sm="6" class="col-xl">
                <FormGroup class="mt-3 mb-0">
                  <Label>{dataPage.filterLabel}:</Label>
                  <input
                    type="date"
                    class="form-control"
                    id="orderid-input"
                    placeholder={dataPage.datePlaceholder}
                    value=""
                  />
                </FormGroup>
              </Col>
              <Col sm="6" class="col-xl">
                <FormGroup class="mt-3 mb-0">
                  <Label>{dataPage.mobilesLabel}</Label>
                  <select class="form-control select2-search-disable">
                    <option value="Todos" defaultValue
                      >{dataPage.mobileDefaultOption}</option
                    >
                    {#each optionsDevices as option, index}
                      <option value={index}>{option}</option>
                    {/each}
                  </select>
                </FormGroup>
              </Col>
              <Col sm="6" class="col-xl">
                <FormGroup class="mt-3 mb-0">
                  <Label>{dataPage.patentTankLabel}</Label>
                  <select class="form-control select2-search-disable">
                    <option value="" defaultValue
                      >{dataPage.patentDefaultOption}</option
                    >
                    {#each truckPatents as patent}
                      <option value={patent}>{patent}</option>
                    {/each}
                  </select>
                </FormGroup>
              </Col>
              <Col sm="6" class="col-xl align-self-end">
                <div class="mb-3 text-end">
                  <Button type="button" color="primary" class="w-md"
                    >{dataPage.filterButton}</Button
                  >
                </div>
              </Col>
            </Row>
          </Form>
          <Card>
            <CardBody>
              <div class="mb-4 h4 card-title">
                {dataPage.devicesFilterTitle}
              </div>
              <div class="table-responsive">
                <table class="table align-middle table-nowrap mb-0">
                  <thead class="table-light">
                    <tr>
                      <th style="width: 20px;">
                        <div class="form-check font-size-16 align-middle">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="transactionCheck01"
                          />
                          <label
                            class="form-check-label"
                            for="transactionCheck01"
                          ></label>
                        </div>
                      </th>
                      <th class="align-middle">Status</th>
                      <th class="align-middle">{dataPage.ordenNumberLabel}</th>
                      <th class="align-middle">{dataPage.dateLabel}</th>
                      <th class="align-middle">{dataPage.hourLabel}</th>
                      <th class="align-middle">{dataPage.deviceIDLabel}</th>
                      <th class="align-middle">{dataPage.patentTruckLabel}</th>
                      <th class="align-middle">{dataPage.billNumberLabel}</th>
                      <th class="align-middle">{dataPage.guideNumberLabel}</th>
                      <th class="align-middle">{dataPage.patentTankLabel}</th>
                      <th class="align-middle">{dataPage.latitudeLabel}</th>
                      <th class="align-middle">{dataPage.longitudeLabel}</th>
                      <th class="align-middle">{dataPage.lacthStatusLabel}</th>
                      <th class="align-middle">{dataPage.batteryLevelLabel}</th>
                      <th class="align-middle">{dataPage.batteryACKLabel}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="form-check font-size-16">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="transactionCheck02"
                          />
                          <label
                            class="form-check-label"
                            for="transactionCheck02"
                          ></label>
                        </div>
                      </td>
                      <td>
                        <i class="mdi mdi-car-brake-alert green font-size-24"
                        ></i>
                      </td>
                      <td>
                        {$user ? $user.username : 'Usuario no autenticado'}
                      </td>
                      <td>
                        {$user
                          ? new Date($user.createdAt).toLocaleDateString()
                          : new Date().toLocaleDateString()}
                      </td>
                      <td>
                        {$user
                          ? new Date($user.createdAt).toLocaleTimeString()
                          : new Date().toLocaleTimeString()}
                      </td>
                      <!-- Se muestra el id del primer dispositivo encontrado para el primer camión -->
                      <td>
                        {($user?.new_profile?.new_company?.new_trucks &&
                          $user.new_profile.new_company.new_trucks[0]
                            ?.new_tanks[0]?.new_devices[0]?.id) ||
                          'N/A'}
                      </td>
                      <td>
                        {($user?.new_profile?.new_company?.new_trucks &&
                          $user.new_profile.new_company.new_trucks[0]
                            ?.Patent) ||
                          'N/A'}
                      </td>
                      <td>
                        {$user?.new_profile?.new_company?.Dispatch_Account ||
                          'N/A'}
                      </td>
                      <td>
                        {$user?.new_profile?.new_company?.Company_code || 'N/A'}
                      </td>
                      <td>
                        {($user?.new_profile?.new_company?.new_trucks &&
                          $user.new_profile.new_company.new_trucks[0]
                            ?.new_tanks[0]?.Name) ||
                          'N/A'}
                      </td>
                      <td>
                        {$user?.new_profile?.new_company?.Latitude ||
                          '-33.0247407'}
                      </td>
                      <td>
                        {$user?.new_profile?.new_company?.Longitude ||
                          '-71.4061115'}
                      </td>
                      <td>{'CERRADO'}</td>
                      <td>{'29 V'}</td>
                      <td>{'80%'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>

          <!-- Sección adicional: Tabla de Camiones y sus dispositivos -->
          <div class="table-responsive" style="margin-top:20px;">
            <h4>Camiones y dispositivos</h4>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Camión</th>
                  <th>ID Dispositivos</th>
                </tr>
              </thead>
              <tbody>
                {#if $user && $user.new_profile && $user.new_profile.new_company && $user.new_profile.new_company.new_trucks}
                  {#each $user.new_profile.new_company.new_trucks as truck}
                    <tr>
                      <td>{truck.Patent || 'N/A'}</td>
                      <td>
                        {#if truck.new_tanks && truck.new_tanks.length > 0}
                          {#each truck.new_tanks as tank}
                            {#if tank.new_devices && tank.new_devices.length > 0}
                              {#each tank.new_devices as device, i}
                                {device.id}{i < tank.new_devices.length - 1
                                  ? ', '
                                  : ''}
                              {/each}
                              <br />
                            {:else}
                              Sin dispositivos.
                            {/if}
                          {/each}
                        {:else}
                          Sin dispositivos.
                        {/if}
                      </td>
                    </tr>
                  {/each}
                {:else}
                  <tr>
                    <td colspan="2">No hay camiones asignados.</td>
                  </tr>
                {/if}
              </tbody>
            </table>
          </div>

          <!-- Mapa mediante MapContainer -->
          <MapContainer {start} {end} />
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <LatestTransactions />
        </Col>
      </Row>
    </Container>
  </div>
{/if}

<style>
  .icono {
    font-size: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 10vh;
  }
  .texto {
    text-align: center !important;
  }
  .alert {
    margin-top: revert;
    text-align: center;
  }
  .green {
    color: #00cc82;
  }
  .orange {
    color: #ff9900;
  }
  .red {
    color: #ee1717;
  }
  .yellow {
    color: #ffe600;
  }
  .blue {
    color: #002bf8;
  }
</style>
